import {useRef, useState} from 'react'
import {Form,App,Input, Modal, Radio} from 'antd'
import MyEditor from '../../cpn/MyEditor';
import { useHouduankaifaAddMutation } from '../../store/BnsKeJiApi';
import { PlusSquareOutlined} from '@ant-design/icons';
import { backendAction } from './backendAction';
const {TextArea} = Input
function BackendAdd(props) {
    console.log(props,'backendadd');
    
    const [open, setOpen] = useState(false);
    const {message} = App.useApp();
    const [form] = Form.useForm();
    const editForm = useRef()
    const [submit] = useHouduankaifaAddMutation();
    const [info,setInfo] = useState({
        etul_content: '',
        etul_uid:localStorage.getItem('eu_id'),
        etul_uname: localStorage.getItem('eu_name'),
        et_status:'1',
        etul_level:'1',
        etul_name:"",
        etul_require:'',
        etul_bg_id:props.bg_id,
        etul_bg_name:props.bg_name,
        etul_bgn_id:props.bgn_id,
        etul_bgn_name:props.bgn_name,
        etul_bbb_id:props.bbb_id,
        etul_bbb_name:props.bbb_name,
        etul_et_id:props.et_id,
        etul_et_name:props.et_name,
    });    
    return (
        <>
            {props.et_id && <a onClick={() => {setOpen(true)}}><PlusSquareOutlined /> 新增任务</a>}
            <Modal
                open={open}
                width={1200}
                title='新增任务'
                onCancel={() => {setOpen(false)}}
                onOk={() => {
                    form.resetFields();  
                    submit({
                        etul_content: info.etul_content,
                        etul_et_id:props.et_id,
                        etul_et_name:props.et_name,
                        etul_uid:localStorage.getItem('eu_id'),
                        etul_uname: localStorage.getItem('eu_name'),
                        etul_state:'1',
                        etul_name:info.etul_name,
                        etul_bg_id:info.etul_bg_id,
                        etul_bg_name:info.etul_bg_name,
                        etul_bgn_id:info.etul_bgn_id,
                        etul_bgn_name:info.etul_bgn_name,
                        etul_bbb_id:info.etul_bbb_id,
                        etul_bbb_name:info.etul_bbb_name,
                        etul_level:info.etul_level,
                        etul_action:info.etul_action,
                        etul_require:info.etul_require,
                        }).then((res) => {
                            // console.log(res);
                            if (res.data.Status === 'success') {
                                message.success('新增成功！')  
                                setOpen(false)
                            }
                            if (res.data.Status === 'fail') {
                                message.error('新增失败！'+res.data.Message)
                            }
                        })      
                }}
            >
                <Form
                    ref={editForm}
                    form={form}
                    layout="horizonal"
                    name={`form_client_add_${props.et_id}`}
                    initialValues={{modifier: 'public',}}
                    labelCol={{ span: 3 }}    
                >                        
                    <Form.Item 
                        name="etul_action" 
                        label='任务类型' 
                        wrapperCol={{span:21}} 
                        required 
                    >                        
                        <Radio.Group   
                            options={backendAction}
                            buttonStyle='solid'
                            optionType="button" 
                            onChange={(e) => {setInfo(prevState=>({...prevState,etul_action:e.target.value,}))}}
                        >
                            
                        </Radio.Group>
                    </Form.Item> 
                    <Form.Item name="etul_name" label='字段名称' wrapperCol={{span:15}}>                        
                        <TextArea  onChange={(e) => {setInfo(prevState=>({...prevState,etul_name:e.target.value,}))}}/>
                    </Form.Item>
                    <Form.Item name="etul_require" label='字段可选' wrapperCol={{span:15}}>                        
                        <TextArea  onChange={(e) => {setInfo(prevState=>({...prevState,etul_require:e.target.value,}))}}/>
                    </Form.Item> 
                    <Form.Item 
                        name="content" 
                        label='任务说明' 
                        wrapperCol={{span:21}}                        
                    >
                        <MyEditor  onChange={(e) => {setInfo(prevState=>({...prevState,etul_content:e}))}}/>
                    </Form.Item>                                                     
                </Form>
            </Modal>
        </>
    )
}

export default BackendAdd